<template>
    <div>
      <suc-page></suc-page>
    </div>
</template>
<script>
import SucPage from '@/components/SucPage/SucPage'
export default {
  components: {
    SucPage
  }
}
</script>
